var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pb-0 overflow-hidden bg-gray-300"},[_c('div',{staticClass:"pb-1 text-xs leading-none text-center bg-blue",style:({ width: _vm.percentage + '%' }),attrs:{"data-testid":"progress"}})])}
var staticRenderFns = []

export { render, staticRenderFns }